export default "__VITE_ASSET__COBfFfrR__"